import React from 'react';
import { ShoppingCart } from 'lucide-react';

// Modal de confirmação "Produto adicionado ao carrinho" do cardápio público.
// Extraído VERBATIM de PublicMenu.js (Fase 2 refactor). Componente puro (sem hooks),
// recebe estado/handlers via props. Renderizado como <CartConfirmationModal .../>.
const CartConfirmationModal = ({
  showCartConfirmation,
  setShowCartConfirmation,
  setCurrentScreen,
}) => {
  if (!showCartConfirmation) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-end justify-center sm:items-center">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
        onClick={() => setShowCartConfirmation(false)}
      />
      
      {/* Modal Content */}
      <div className="relative bg-white rounded-t-3xl sm:rounded-2xl w-full max-w-md p-6 shadow-2xl animate-slide-up">
        <div className="text-center">
          {/* Success Icon - Carrinho com animação de pulo único + pulso contínuo */}
          <div 
            className="mx-auto w-20 h-20 rounded-full flex items-center justify-center mb-4 shadow-lg animate-cart-bounce-once"
            style={{
              background: `linear-gradient(to bottom right, var(--color-primary-light, #EFF6FF), var(--color-primary-light, #EFF6FF))`
            }}
          >
            <ShoppingCart 
              className="w-10 h-10 animate-cart-pulse" 
              style={{ color: 'var(--color-primary, #3B82F6)' }}
            />
          </div>
          
          {/* Message */}
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            Produto Adicionado! ✓
          </h3>
          <p className="mb-6 font-medium" style={{ color: 'var(--color-primary, #3B82F6)' }}>
            Item adicionado ao carrinho com sucesso
          </p>
          
          {/* Buttons - ORDEM INVERTIDA */}
          <div className="space-y-3">
            <button
              onClick={() => {
                setShowCartConfirmation(false);
                setCurrentScreen('home');
              }}
              className="w-full bg-white text-primary py-3 px-4 rounded-lg font-semibold hover:bg-primary-light transition-all duration-200 border-2 border-primary shadow-sm hover:shadow-md"
            >
              Continuar Comprando
            </button>
            
            <button
              onClick={() => {
                setShowCartConfirmation(false);
                setCurrentScreen('cart');
              }}
              className="w-full text-white py-3 px-4 rounded-lg font-bold transition-all duration-200 animate-slow-pulse hover:animate-none"
              style={{
                background: `linear-gradient(to right, var(--color-primary, #3B82F6), var(--color-primary-hover, #2563EB))`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = `linear-gradient(to right, var(--color-primary-hover, #2563EB), var(--color-primary-hover, #2563EB))`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = `linear-gradient(to right, var(--color-primary, #3B82F6), var(--color-primary-hover, #2563EB))`;
              }}
            >
              Ir para o Carrinho
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartConfirmationModal;
